import { Outlet } from "react-router-dom";
import { Stack } from "@volca/ui/components/ui/stack";

const PayrollSettings = () => (
  <Stack
    align="start"
    gap={0}
    className="h-page w-full min-w-0 overflow-hidden"
  >
    <Outlet />
  </Stack>
);

export default PayrollSettings;
